module.exports = __webpack_public_path__ + "media/images/athletes/1731-c88fe36af0ddcf5530e1a4f0339902fc.png";